import { render } from "./VoiceRecording.vue?vue&type=template&id=6d37bb27&scoped=true"
import script from "./VoiceRecording.vue?vue&type=script&lang=js"
export * from "./VoiceRecording.vue?vue&type=script&lang=js"

import "./VoiceRecording.vue?vue&type=style&index=0&id=6d37bb27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d37bb27"]])

export default __exports__